import OpenSeadragon from 'openseadragon'
import ruler from '../ruler'
import multiViewControls from '../multiViewControls'
import { setupFullscreenButton } from './fullscreen'
import ganalytics from '../ganalytics'
import uiConfiguration from '../uiConfiguration'

function createViewerDom() {
  const viewer = `	
<div id="viewer" class="viewer split-viewer" style="width:100%; left:0">
</div>
`

  const widgetContainer = document.getElementById('widgetContainer')
  widgetContainer.insertAdjacentHTML('beforeend', viewer)
}

function updateImages(state, viewer) {
  const visibleImagesStates = state.filter(state => state.visible)

  if (visibleImagesStates.length > 0) {
    viewer.open(visibleImagesStates[0].tileSources[0])
    visibleImagesStates.slice(1).forEach(data => {
      viewer.addTiledImage({
        tileSource: data.tileSources[0],
        opacity: 1
      })
    })
  } else {
    viewer.open(null)
  }
}

function init(imagesData, customUIName) {
  createViewerDom()
  const viewer = OpenSeadragon({
    tileSources: null,
    prefixUrl: 'openseadragon/',
    id: 'viewer',
    homeFillsViewer: false,
    navigatorHeight: '184px',
    navigatorWidth: '184px',
    ppi: imagesData[0].ppi,
    preserveImageSizeOnResize: true,
    loadTilesWithAjax: true,
    gestureSettingsMouse: {
      flickEnabled: false,
      clickToZoom: false,
      dblClickToZoom: true
    },
    animationTime: 1.75,
    maxZoomPixelRatio: imagesData[0].maxZoomPixelRatio,
    rotateRightButton: imagesData[0].canRotate ? 'rotate' : null,
    rotationIncrement: imagesData[0].canRotate ? 45 : 0,
    showRotationControl: true
  })

  imagesData.forEach((imageData, index) => {
    viewer.addTiledImage({
      tileSource: imagesData[index].tileSources[0],
      opacity: 1
    })
  })

  const initialZoomLevel = viewer.viewport.getZoom(true)

  document.getElementById('home').addEventListener('click', () => {
    viewer.viewport.zoomTo(initialZoomLevel, null, false)
    viewer.viewport.panTo(new OpenSeadragon.Point(0.5, 0.5), false)
  })

  viewer.trackerMouse = new OpenSeadragon.MouseTracker({
    element: viewer.element,
    moveHandler: function (event) {
      viewer.world._items.forEach((item, index) => {
        const position = viewer.viewport.pointFromPixel(event.position)
        const transformation = transformations[index]

        const x = transformation.x(position.x)
        const y = Math.max(0, transformation.y(position.y))
        const width = transformation.w(position.x)
        const height = transformation.h(position.y)

        item.setClip(item.viewportToImageRectangle(x, y, width, height))
      })
    }
  })

  const rulerDom = document.getElementById('ruler')
  ruler.setupRulerToggleButton(rulerDom)
  ruler.onCanvasClickSetup(viewer, rulerDom)

  multiViewControls.createDom(imagesData)

  const viewerElement = document.getElementById('viewer')
  viewerElement.addEventListener('changeSelectedImage', e => {
    updateImages(e.detail.state, viewer)
    if (e.detail.viewerPosition) {
      viewer.addHandler('open', () => {
        if (e.detail.viewerRotation) {
          viewer.viewport.setRotation(e.detail.viewerRotation)
        }
        viewer.viewport.fitBounds(e.detail.viewerPosition, true)
      })
    }
  })

  viewerElement.addEventListener('updateImagesVisibility', e => {
    updateImages(e.detail.state, viewer)
  })

  setupFullscreenButton(viewer, customUIName)

  let analyticsCustomerCode = uiConfiguration.getConfigurationFor(customUIName, 'analyticsCustomerCode')

  ganalytics.setupAnalyticsCustomButtons(imagesData[0], analyticsCustomerCode)
  ganalytics.setupAnalyticsForOpenSeaDragon(viewer, imagesData[0], analyticsCustomerCode, true)

  return [viewer]
}

const transformations = {
  0: { x: x => 0, y: y => 0, w: w => 2, h: h => 2 },
  1: { x: x => 0, y: y => y, w: w => 2, h: h => 2 },
  2: {
    x: x => Math.min(2, Math.max(0, x)),
    y: y => 0,
    w: w => 2,
    h: h => h
  },
  3: {
    x: x => Math.min(2, Math.max(0, x)),
    y: y => Math.min(2, y),
    w: w => w,
    h: h => h
  }
}

export default { init }
